<template>
  <div class="feature-section">
    <div class="section-title">特色专栏</div>
    <div class="cards-container">
      <div 
        class="card large-card" 
        v-for="(item, index) in largeCards" 
        :key="'large-' + index"
        @click="handleCardClick1(item)"
      >
        <div class="card-image" :style="{ backgroundImage: item.image ? `url(${item.image})` : '', backgroundColor: !item.image ? getColor(index) : '' }"></div>
        <div class="card-text">
          <span>{{ item.name }}</span>
          <span class="sub">{{ item.floor_code }} {{ item.business_type }}</span>
        </div>
      </div>
      <!-- Fallback if no data -->
      <template v-if="largeCards.length === 0">
        <div class="card large-card">
           <div class="card-image img-1"></div>
           <div class="card-text">
             <span>暂无数据</span>
             <span class="sub">--</span>
           </div>
        </div>
        <div class="card large-card">
           <div class="card-image img-2"></div>
           <div class="card-text">
             <span>暂无数据</span>
             <span class="sub">--</span>
           </div>
        </div>
      </template>
    </div>
    
    <div class="cards-row">
      <div 
        class="card small-card" 
        v-for="(item, index) in smallCards" 
        :key="'small-' + index"
        @click="handleCardClick(item)"
      >
        <div class="card-image" :style="{ backgroundImage: item.image ? `url(${item.image})` : '', backgroundColor: !item.image ? '#ffafcc' : '' }"></div>
        <div class="card-text-small">
          <span>{{ item.name }}-{{ item.business_type }}</span>
          <span class="sub">{{ item.floor_code }} </span>
        </div>
      </div>
       <!-- Fallback if no data -->
      <template v-if="smallCards.length === 0">
        <div class="card small-card" v-for="i in 4" :key="i">
            <div class="card-image img-small"></div>
            <div class="card-text-small">
            <span>暂无数据</span>
            <span class="sub">--</span>
            </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { BackendService } from '@/api';

export default {
  name: 'FeatureSection',
  emits: ['open-chat-with-context'],
  data() {
    return {
      features: [],
      loading: false
    }
  },
  computed: {
    largeCards() {
      // this.features中type=2的前2项
      return this.features.filter(item => item.type === 2).slice(0, 2);
    },
    smallCards() {
      // this.features中type=1的前4项
      return this.features.filter(item => item.type === 1).slice(0, 4);
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    getColor(index) {
        const colors = ['#a2d2ff', '#cdb4db'];
        return colors[index % colors.length];
    },
    async fetchData() {
      this.loading = true;
      try {
        // Fetch data from api/mall.mall_floor/lists
        // BackendService now returns response.data directly (the payload)
        const data = await BackendService.get('/mall.mall_floor/lists');
        console.log('FeatureSection data:', data);
        
        if (data && Array.isArray(data.lists)) {
             this.features = data.lists;
        } else {
            console.warn('Unexpected API response format', data);
        }
      } catch (error) {
        console.error('Failed to fetch feature section data:', error);
      } finally {
        this.loading = false;
      }
    },
    handleCardClick(item) {
        // Emit event to open chat with context
        // console.log(item);
        let question = '我想去' + item.name  + item.floor_code + item.business_type;
        console.log(question);
        this.$emit('open-chat-with-context', question);
    },
    handleCardClick1(item) {
        // Emit event to open chat with context
        // console.log(item);
        let question = '我想去' + item.name;
        console.log(question);
        this.$emit('open-chat-with-context', question);
    }
  }
}
</script>

<style scoped>
.feature-section {
  display: flex;
  flex-direction: column;
  gap: 0.8vh; /* Reduced gap */
  height: 100%;
}

.section-title {
  color: #fff;
  font-size: 1rem; /* Slightly smaller */
  font-weight: bold;
  flex: 0 0 auto;
}

.cards-container {
  display: flex;
  gap: 0.8vh; /* Reduced gap */
  flex: 1.2;
  min-height: 0;
}

.card {
  background: #fff;
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  height: 100%;
}

.large-card {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.card-image {
  background: #ccc;
  flex: 1;
  background-size: cover;
  background-position: center;
}
.img-1 { background-color: #a2d2ff; }
.img-2 { background-color: #cdb4db; }
.img-small { background-color: #ffafcc; }

.card-text {
  padding: 0.6vh 0.8vw; /* Reduced padding */
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 0.75rem; /* Reduced */
  flex: 0 0 auto;
}

.cards-row {
  display: flex;
  gap: 0.8vh; /* Reduced gap */
  flex: 1;
  min-height: 0;
}

.small-card {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.card-text-small {
  padding: 0.4vh;
  font-size: 0.65rem; /* Reduced */
  text-align: center;
  flex: 0 0 auto;
}

.sub {
  font-size: 0.6rem; /* Reduced */
  color: #888;
}
</style>
